import previewFile from "./previewFile";

export default (url) => previewFile({url});